<template>
  <div>
    <b-card>
      <page-title v-if="titleStatus" :title="$t('tracks.items')" />

      <main-table
        :fields="fields"
        :list_url="'admin/track'"
        :reloadData="reloadData"
        :params="filter"
        :createBtnLabel="$t('tracks.create')"
        createRouteName="events.trackCreate"
        :excelFields="excelFields"
        excelName="tracks"
        :downloadSampleStatus="true"
        downloadSampleUrl="track/excel-sample"
        :uploadFileStatus="true"
        uploadFileUrl="track/excel"
      />
    </b-card>
  </div>
</template>
<script>
import { core } from "../../../../config/pluginInit";
import TrackFilter from "../models/TrackFilter";
import searchMixin from "../../../../Mixins/searchMixin";

export default {
  mixins: [searchMixin],
  data() {
    return {
      filter: new TrackFilter(),
      fields: [
        this.$t("global.selected"),
        { key: "id", label: this.$t("table.id"), sortable: true },
        { key: "name", label: this.$t("table.name"), sortable: true },
        {
          key: "location.address",
          label: this.$t("locations.item"),
          sortable: true,
        },
        {
          key: "created_at",
          label: this.$t("table.createdAt"),
          type: "dateTime",
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("table.actions"),
          type: "actions",
          actions: [
            {
              text: this.$t("global.view"),
              icon: "fas fa-eye",
              color: "info",
              ifNavigate: true,
              routeName: "events.trackView",
              routeParams: ["id"],
            },
            {
              text: this.$t("global.update"),
              icon: "fas fa-pen",
              color: "primary",
              ifNavigate: true,
              routeName: "events.trackUpdate",
              routeParams: ["id"],
            },
            {
              text: this.$t("global.delete"),
              icon: "fas fa-trash-alt",
              color: "danger",
              showAlert: true,
              actionHeader: this.$t("global.delete"),
              titleHeader: this.$t("tracks.item"),
              textContent: "name",
              url: "admin/track",
              type: "delete",
            },
          ],
        },
      ],
      excelFields: {
        [this.$t("table.id")]: "id",
        [this.$t("table.name")]: "name",
        [this.$t("locations.item")]: "location.address",
        [this.$t("table.createdAt")]: "created_at",
      },
    };
  },
  mounted() {
    core.index();
  },
};
</script>
